// extracted by mini-css-extract-plugin
module.exports = {"downloadBtnWrapper":"downloadReport_downloadBtnWrapper__3Z_DY","download":"downloadReport_download__3RzFr"};